import React, { Component } from 'react';
import moment from 'moment';
import DataTable from 'react-data-table-component';
import queryString from 'query-string';
import SearchComponent from './Components/SearchComponent';
import TodaysEventsEmpty from './Components/TodaysEventsEmpty';

import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { history } from '../../_helpers/history';
import { alertActions } from '../../_actions/alert.actions';
import { eventService } from '../../_services/event.service';

const columns = [
  {
    name: 'Status',
    grow: 1,
    sort: false,
    cell: row => {
      return <span className='badge badge-info text-uppercase'>{row.status}</span>
    }
  },
  {
    name: 'Type',
    grow: 3,
    sort: false,
    cell: row => {
      return <span className='badge badge-info text-uppercase'>{
        `${row.type.slice(0, 20)}${row.type.length > 20 ? '...' : ''}`
      }</span>
    }
  },
  {
    name: 'Date',
    grow: 2,
    sort: false,
    cell: row => {
      if (row.date && row.time) {
        return moment.tz(`${row.date}T${row.time}`, row.providerGroup.timezone)
          .local()
          .format('l LT')
      } else {
        return moment.tz(`${row.date}`, row.providerGroup.timezone)
          .local()
          .format('l')
      }
    }
  },
  {
    name: 'First Name',
    sort: false,
    cell: row => {
      if (row.userProfile) {
        return `${row.userProfile.firstName}`
      } else {
        return `${row.patientFirstName}`
      }
    }
  },
  {
    name: 'Last Name',
    sort: false,
    cell: row => {
      if (row.userProfile) {
        return `${row.userProfile.lastName}`
      } else {
        return `${row.patientLastName}`
      }
    }
  },
  {
    name: 'Provider',
    sort: false,
    cell: row => `${row.doctor.firstName} ${row.doctor.lastName}`
  },
  {
    name: 'Location',
    grow: 2,
    sort: false,
    cell: row => row.providerGroup.name
  },
  {
    button: true,
    width: '100px',
    sort: false,
    cell: row => <Link className="btn btn-outline-primary btn-sm" to={`/events/${row.id}/details`}>Details</Link>
  }
];

class TodaysEventsTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      total: null,
      events: [],
      initLoad: true,
      isLoading: false
    }
  }

  componentDidMount() {
    if (this.props.currentUser.UserType.Name === 'Licensed') {
      const providerId = this.props.currentUser.Doctor.DoctorId;

      this.props.history.push(`/dashboard/events?professional=${providerId}&time=${Date.now()}`)
    } else {
      this.loadData();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      if (this.state.initLoad && this.state.events.length > 0) {
        this.setState({ initLoad: false })
      }
      this.loadData();
    }
  }

  loadData() {
    const searchParams = this.searchParams();

    this.setState({ isLoading: true });

    eventService.getEvents(searchParams)
      .then(response => {
        this.setState({
          total: response.total,
          events: response.collection.data,
          isLoading: false
        })
      })
      .catch(() => {
        this.setState({ isLoading: false })

        this.props.dispatch(alertActions.error('Could not retrieve events at this time. Please try again.'))
      })
  }

  searchParams() {
    const queryParams = queryString.parse(this.props.location.search);

    return {
      page: queryParams.page || 1,
      firstName: queryParams.firstName || '',
      lastName: queryParams.lastName || '',
      dateOfBirth: queryParams.dateOfBirth || '',
      date: moment().local().format('MM/DD/YYYY'),
      groupId: queryParams.location ? parseInt(queryParams.location) : '',
      providerId: queryParams.professional ? parseInt(queryParams.professional) : '',
      eventType: queryParams.eventType ? parseInt(queryParams.eventType) : '',
    }
  }

  render() {
    const { isLoading, total } = this.state;

    const urlParams = this.searchParams();

    if (this.state.initLoad && isLoading) {
      return <Spinner animation="border" role="status" />
    }

    else if (this.state.initLoad && this.state.events.length === 0) {
      return <TodaysEventsEmpty />
    }

    else {
      return <div className="row">
        <div className="col-lg-12">
          <DataTable
            title="Today's Events"
            data={this.state.events}
            columns={columns}
            progressPending={isLoading}
            subHeader
            subHeaderComponent={
              <SearchComponent
                location={this.props.location}
                handleClear={() => history.push('/dashboard/events')}
                handleSearch={(params) => {
                  const { firstName, lastName, locationId, professional } = params;
                  history.replace(`/dashboard/events?firstName=${firstName}&lastName=${lastName}&location=${locationId}&professional=${professional}`)
                }} />
            }
            onChangePage={page => {
              const queryParams = queryString.parse(this.props.location.search);
              const showDateRange = ("eventStartDate" in queryParams) ? true : false;

              const firstName = queryParams.firstName || '';
              const lastName = queryParams.lastName || '';
              const dateOfBirth = queryParams.dateOfBirth || '';
              const date = queryParams.date || '';
              const eventStartDate = queryParams.eventStartDate || '';
              const eventEndDate = queryParams.eventEndDate || '';
              const location = queryParams.location ? parseInt(queryParams.location) : '';
              const professional = queryParams.professional ? parseInt(queryParams.professional) : '';
              const eventType = queryParams.eventType ? parseInt(queryParams.eventType) : '';

              history.replace(`/dashboard/events?page=${page}&firstName=${firstName}&lastName=${lastName}&dateOfBirth=${dateOfBirth}${showDateRange ? `&eventStartDate=${eventStartDate}&eventEndDate=${eventEndDate}` : `&date=${date}`}&location=${location}&professional=${professional}&eventType=${eventType}`)
            }}
            striped={true}
            pagination={true}
            paginationServer={true}
            paginationTotalRows={total}
            paginationRowsPerPageOptions={[15]}
            paginationPerPage={15}
            paginationDefaultPage={parseInt(urlParams.page)}
            noDataComponent={<div className="p-4">We could not find any results based on your search criteria</div>}
            customStyles={{ subHeader: { style: { padding: '0px' }, }, cells: { style: { fontSize: '14px', paddingTop: '.5em', paddingBottom: '.5em' }, }, }}
          />
        </div>
      </div>
    }
  }
}

function mapStateToProps(state) {
  return {
    currentUser: state.user.currentUser
  };
}


export default connect(mapStateToProps)(TodaysEventsTable);